import type { Channel } from "@/types";

export const CHANNEL_LIMITS: Record<Channel, number> = {
  whatsapp: 4096,
  telegram: 4000,
  web: 4096,
  instagram: 4096,
};
